import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MarketingPageHeader from "@/components/MarketingPageHeader";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  HelpCircle,
  CreditCard,
  CalendarCheck,
  UserCircle,
  BookOpen,
  Mail,
} from "lucide-react";

const helpTopics = [
  {
    icon: UserCircle,
    titleKey: "help.topics.account.title",
    descriptionKey: "help.topics.account.description",
    link: "/faq",
  },
  {
    icon: CalendarCheck,
    titleKey: "help.topics.booking.title",
    descriptionKey: "help.topics.booking.description",
    link: "/faq",
  },
  {
    icon: CreditCard,
    titleKey: "help.topics.credits.title",
    descriptionKey: "help.topics.credits.description",
    link: "/faq",
  },
  {
    icon: BookOpen,
    titleKey: "help.topics.courses.title",
    descriptionKey: "help.topics.courses.description",
    link: "/faq",
  },
  {
    icon: HelpCircle,
    titleKey: "help.topics.community.title",
    descriptionKey: "help.topics.community.description",
    link: "/community-guidelines",
  },
  {
    icon: Mail,
    titleKey: "help.topics.contact.title",
    descriptionKey: "help.topics.contact.description",
    link: "mailto:hello@jynio.co",
  },
];

const Help = () => {
  const { t } = useTranslation();

  return (
  <div className="min-h-screen bg-background">
    <Header />
    <MarketingPageHeader title={t("help.heading")} subtitle={t("help.intro")} containerClassName="max-w-3xl" />
    <main className="container mx-auto px-4 pb-24 pt-6 max-w-3xl">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12">
        {helpTopics.map((topic) => {
          const Icon = topic.icon;
          const isExternal = topic.link.startsWith("mailto:");

          const content = (
            <Card className="h-full shadow-card hover:shadow-hover transition-shadow cursor-pointer">
              <CardContent className="p-6">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center mb-3">
                  <Icon className="w-5 h-5 text-foreground" />
                </div>
                <h3 className="font-semibold text-foreground mb-1">{t(topic.titleKey)}</h3>
                <p className="text-sm text-muted-foreground">{t(topic.descriptionKey)}</p>
              </CardContent>
            </Card>
          );

          return isExternal ? (
            <a key={topic.titleKey} href={topic.link}>
              {content}
            </a>
          ) : (
            <Link key={topic.titleKey} to={topic.link}>
              {content}
            </Link>
          );
        })}
      </div>

      <div className="prose text-muted-foreground space-y-4 text-sm">
        <h2 className="text-lg font-semibold text-foreground">{t("help.stillHaveQuestions")}</h2>
        <p>
          {t("help.checkFaqPrefix")}{" "}
          <Link to="/faq" className="text-foreground underline">
            {t("help.faqPageLink")}
          </Link>{" "}
          {t("help.checkFaqMiddle")}{" "}
          <a href="mailto:hello@jynio.co" className="text-foreground underline">
            hello@jynio.co
          </a>. {t("help.responseTime")}
        </p>
      </div>
    </main>
    <Footer />
  </div>
  );
};

export default Help;
